export const LOADING_DATA_STATUS_STARTED = 'started';
export const LOADING_DATA_STATUS_DONE = 'done';
export const POPUP_ERROR = 'error';
export const POPUP_SUCCESS = 'success';
export const POPUP_INFO = 'info';
